import { useLanderConfig } from "../commons/ConfigContext";
import { System } from "../commons/Constants";
import { ExperimentIds } from "../commons/constants/experiment";

/** The treatment cohort of parking_llm_keywords, as ParkWeb API names it. */
export const LLM_KEYWORDS_COHORT = "llm";

/**
 * LLM keywords experiment (ParkWeb, PARKING-5307).
 *
 * The API decides who sees LLM terms: only the `llm` cohort gets
 * `keywords.source: llm`, and it stamps both arms' Yahoo type tags
 * (pwYahooLlmKwControl / pwYahooLlmKwTreatment). This hook only reports the
 * `llm` cohort so the RollerAds 1-click clicks of that arm can go to their
 * own account (pid 387), whose report then carries the arm's RollerAds
 * revenue. The cohort is matched exactly, as the API matches it: `control`,
 * any other name and every other experiment are not in it.
 */
export function useLlmKeywordsExperiment() {
  const { landerConfig } = useLanderConfig();
  const { key, cohort } = landerConfig.experiment || {};

  const inLlmKeywordsCohort =
    key === ExperimentIds.llmKeywords &&
    cohort === LLM_KEYWORDS_COHORT &&
    landerConfig.system === System.PARKWEB;

  return { inLlmKeywordsCohort };
}
